export const axiosCustomInstance = (axiosInstance, headers) => {
  axiosInstance = axiosInstance.create({
    baseURL: process.env.VUE_APP_API_ACTIVAMB,
    headers: headers,
  })
  return axiosInstance;
}

export const axiosPDFInstance = (axiosInstance, headers) => {
  axiosInstance = axiosInstance.create({
    baseURL: process.env.VUE_APP_API_ACTIVAMB,
    headers: headers,
  })
  return axiosInstance;
}

export const axiosCustomAuth = (axiosInstance, token) => {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`; 
  return axiosInstance;
}
